import MapboxDraw from '@mapbox/mapbox-gl-draw'
import { cursors, events, modes } from '@mapbox/mapbox-gl-draw/src/constants'
import * as CommonSelectors from '@mapbox/mapbox-gl-draw/src/lib/common_selectors'
import doubleClickZoom from '@mapbox/mapbox-gl-draw/src/lib/double_click_zoom'
import isEventAtCoordinates from '@mapbox/mapbox-gl-draw/src/lib/is_event_at_coordinates'

// Create a shallow copy of the default draw_line_string mode to customize it
const DrawRouteMode = { ...MapboxDraw.modes.draw_line_string }

// MUST BE FIXED !!!
DrawRouteMode.clickAnywhere = function (state, e) {
  if (
    state.currentVertexPosition > 0 &&
    isEventAtCoordinates(e, state.line.coordinates[state.currentVertexPosition - 1])
  ) {
    return this.changeMode(modes.DIRECT_SELECT, { featureId: state.line.id })
  }
  this.updateUIClasses({ mouse: cursors.ADD })
  // Use updateCoordinate and addCoordinate for lines
  state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat)
  state.currentVertexPosition++
  state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat)
  if (this.map) {
    const mapInstance = this.map
    const featureGeoJSON = state.line.toGeoJSON()
    setTimeout(() => {
      mapInstance.fire('draw.route_click', {
        feature: featureGeoJSON,
      })
    }, 0)
  }
}

DrawRouteMode.clickOnVertex = function (state) {
  if (state.currentVertexPosition > 2) {
    return this.changeMode(modes.DIRECT_SELECT, { featureId: state.line.id })
  }
}

DrawRouteMode.toDisplayFeatures = function (state, geojson, display) {
  const isActiveLine = geojson.properties.id === state.line.id
  geojson.properties.active = isActiveLine ? 'true' : 'false'
  if (!isActiveLine) return display(geojson)

  if (geojson.geometry.coordinates.length < 2) return
  geojson.properties.meta = 'feature'

  // Display a vertex for EVERY coordinate, not just the last one
  geojson.geometry.coordinates.forEach((coord, index) => {
    // CRITICAL: Do NOT render the vertex at the current cursor position, otherwise map clicks hit the vertex instead of the map!
    if (index === state.currentVertexPosition) return

    display({
      type: 'Feature',
      properties: {
        meta: 'vertex',
        parent: state.line.id,
        coord_path: `${index}`,
        active: 'false',
      },
      geometry: {
        type: 'Point',
        coordinates: coord,
      },
    })
  })

  display(geojson)
}

DrawRouteMode.onStop = function (state) {
  this.updateUIClasses({ mouse: cursors.NONE })
  doubleClickZoom.enable(this)
  this.activateUIButton()

  // check to see if we've deleted this feature
  if (this.getFeature(state.line.id) === undefined) return

  //remove last added coordinate
  state.line.removeCoordinate(`${state.currentVertexPosition}`)
  if (state.line.isValid()) {
    this.map.fire(events.CREATE, {
      features: [state.line.toGeoJSON()],
    })
  } else {
    this.deleteFeature([state.line.id], { silent: true })
    // this.changeMode(modes.DIRECT_SELECT, { featureId: state.line.id }, { silent: true })
  }
}

DrawRouteMode.onKeyUp = function (state, e) {
  if (CommonSelectors.isEscapeKey(e)) {
    state.currentVertexPosition = 0
    state.line.coordinates = []
  } else if (CommonSelectors.isEnterKey(e)) {
    this.changeMode(modes.DIRECT_SELECT, { featureId: state.line.id })
  }
}

export default DrawRouteMode
